export enum PaymentMethodEnum {
    CartaoRecorrente = 1,
    CartaoParcelado = 2,
    PIX = 3
}